import { takeEvery } from 'redux-saga/effects';
import * as actions from 'data/subscriptions/subscriptionsActions';
import { getQcsSyncResources } from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';
import { mkSubscription } from 'data/subscriptions/subscriptionsTypes';

const mkResourceConfig = (props) => mkQcsSyncResourceConfig({
  resourceName: 'subscriptions',
  resourceBaseUrl: '/subscriptions',
  axiosConfig: { headers: { 'qcs-dataset-id': null } },
  transformResponseToResources: (response: any) => response.data.map((subscription) => mkSubscription(subscription)),
  getLastSyncDate: () => null,
  ...props,
});

export function* getSubscriptionActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.getSubscriptionsSuccess,
    failureAction: actions.getSubscriptionsFailure,
  });
  yield takeEvery(actions.getSubscriptions, getQcsSyncResources, config);
}

export default [
  getSubscriptionActionWatcher,
];
